import { render, staticRenderFns } from "./ElectronicaFqa.vue?vue&type=template&id=f64dc276&scoped=true"
import script from "./ElectronicaFqa.vue?vue&type=script&lang=js"
export * from "./ElectronicaFqa.vue?vue&type=script&lang=js"
import style0 from "./ElectronicaFqa.vue?vue&type=style&index=0&id=f64dc276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64dc276",
  null
  
)

export default component.exports